import { forwardRef } from "react";
import { PaperPlaneTilt } from "@phosphor-icons/react";

// The bottom composer bar. Uses forwardRef so the parent can pin the whole
// <form> to the visible viewport top-of-keyboard.
const Composer = forwardRef(function Composer(
  { taRef, draft, sending, keyboardOpen, onSubmit, onChange, onFocusScroll },
  ref,
) {
  return (
    <form
      ref={ref}
      onSubmit={onSubmit}
      className="px-3 pt-1.5 flex items-end gap-2 border-t border-[#EAEAEA] fixed left-0 right-0 z-30"
      style={{
        bottom: 0,
        paddingBottom: keyboardOpen ? "0px" : "calc(env(safe-area-inset-bottom) + 4px)",
        background: "rgba(255,255,255,0.98)",
        backdropFilter: "blur(16px) saturate(140%)",
        WebkitBackdropFilter: "blur(16px) saturate(140%)",
      }}
      data-testid="room-composer"
    >
      <button
        type="submit"
        disabled={sending || !draft.trim()}
        onMouseDown={(e) => e.preventDefault()}
        onTouchStart={(e) => e.preventDefault()}
        className="shrink-0 w-11 h-11 rounded-full bg-gradient-to-br from-[#10B981] to-[#059669] text-white flex items-center justify-center disabled:opacity-40 active:scale-90 transition shadow-[0_4px_14px_rgba(16,185,129,0.5)]"
        data-testid="room-send"
        aria-label="إرسال"
      >
        <PaperPlaneTilt size={19} weight="fill" style={{ transform: "scaleX(-1)" }} />
      </button>
      <textarea
        ref={taRef}
        rows={1}
        value={draft}
        onChange={(e) => onChange(e.target.value)}
        onFocus={onFocusScroll}
        onKeyDown={(e) => {
          if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            onSubmit(e);
          }
        }}
        placeholder="اكتب رسالتك…"
        className="flex-1 bg-[#F4F4F2] rounded-[22px] px-4 py-2.5 outline-none border border-[#EAEAEA] focus:border-[#10B981] focus:bg-white resize-none transition-colors"
        data-testid="room-input"
        dir="rtl"
        enterKeyHint="send"
        style={{
          minHeight: 44,
          maxHeight: 140,
          fontSize: 16,
          lineHeight: 1.45,
          color: "#0A192F",
          caretColor: "#10B981",
          textAlign: "right",
        }}
      />
    </form>
  );
});

export default Composer;
